<template>
  <section class="loader-wrapper">
    <infinity-spinner class="spinner"/>
    <div class="loader-text">{{ text }}</div>
  </section>
</template>
<script lang="ts" setup>
import InfinitySpinner from './InfinitySpinner.vue';

withDefaults(defineProps<{
  text?:string,
}>(), {
  text: 'Aan het laden...',
});

</script>
<style lang="scss">
.loader-wrapper {
  height: 65px;
  width: 100%;

  margin-top: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .spinner {
    svg {
      stroke: var(--pidz-blue);
    }
  }

  .loader-text {
    font-size: 14px;
    color: var(--pidz-body-text);
  }
}
</style>
